import { render, staticRenderFns } from "./libraryBarChart.vue?vue&type=template&id=774d71e3&scoped=true"
import script from "./libraryBarChart.vue?vue&type=script&lang=js"
export * from "./libraryBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d71e3",
  null
  
)

export default component.exports